import React, { FC } from "react";
import { ThemeBuilderSectionLine } from "./ThemeBuilderSectionLine";
import { WidgetValuePicker, WidgetValuePickerChildrenProps } from "./WidgetValuePicker";
import { Select } from "@xapp/components";
import style from "./style.scss";

export interface WidgetFontFamilyPickerProps {
    readonly label?: string;
    readonly value: string | undefined;
    readonly defaultValue: string | undefined;
    readonly disabled?: boolean;
    onChange(value: string): void;
}


export const WidgetFontFamilyPickerRaw: FC<WidgetValuePickerChildrenProps<string>> = ({
    override,
    disabled,
    onChange,
    value,
}: WidgetValuePickerChildrenProps<string>) => {

    const fonts: string[] = [
        "Arial",
        "Baskerville",
        "Brush Script MT",
        "Comic Sans MS",
        "Courier New",
        "Garamond",
        "Georgia",
        "Gill Sans",
        "Helvetica",
        "Impact",
        "Lucida",
        "Monaco",
        "Monospace",
        "Palatino",
        "RobotoRegular",
        "Sans-Serif",
        "Serif",
        "Tahoma",
        "Times New Roman",
        "Trebuchet MS",
        "Verdana",
    ];

    // If they entered a custom value, we want to make sure we can display that.

    if (value && !fonts.includes(value)) {
        fonts.push(value);
    }

    const items = fonts.map((font) => ({ label: font, value: font }))

    return (
        <Select
            items={items}
            className={style.fontFamilyValue}
            disabled={override || disabled}
            value={value}
            fullWidth
            onChange={(value: string) => onChange(value)} />
    );
};

export const WidgetFontFamilyPicker: FC<WidgetFontFamilyPickerProps> = props => {
    return (
        <ThemeBuilderSectionLine label={props.label ?? "Font family"}>
            <WidgetValuePicker<string>
                value={props.value}
                defaultValue={props.defaultValue}
                children={WidgetFontFamilyPickerRaw}
                disabled={props.disabled}
                onChange={props.onChange}
            />
        </ThemeBuilderSectionLine>
    );
};